<template>
  <div id="app">
    <div class="content">
      <div id="demo"></div>
      <div id="demo1"></div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import { Dialog } from "vant";
import Pdfh5 from "pdfh5";
import "pdfh5/css/pdfh5.css";
import { Toast } from "vant";
export default {
  mounted() {
    this.chakan();
  },

  data() {
    return {
      base64Arr: [],
      pdfh5: null,
      src1: "",
      src2: "",
    };
  },
  methods: {
    chakan() {
      this.$toast.loading({
        message: "信息获取中...",
        forbidClick: true,
      });
      let params = qs.stringify({
        cardType: 8,
      });
      this.$axios
        .post("identity/user/elecCertificate/getCertificateInfo", params)
        .then((res) => {
          console.log(res);
          if (res.data.result !== 1) {
             Toast.clear()
            Dialog.alert({
              message: res.data.reason,
            }).then(() => {});
            return;
          }
          if (res.data.result === 1) {
            res.data.data.forEach((item) => {
              this.base64Arr.push(item);
            });
            this.src1 = this.base64Arr[0].PDF;
            this.src2 = this.base64Arr[1].PDF;
            this.showPdf1();
            this.showPdf();
             Toast.clear()
          }
        })
        .catch((err) => {
           Toast.clear()
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
    showPdf() {
      //遍历后台传过来的pdfDataList
      let base64 = this.src1; //获得bas464编码
      let decodedBase64 = atob(base64); //使用浏览器自带的方法解码
      this.pdfh5 = new Pdfh5("#demo", {
        data: decodedBase64,
      });
    },
    showPdf1() {
      //遍历后台传过来的pdfDataList
      let base64 = this.src2; //获得bas464编码
      let decodedBase64 = atob(base64); //使用浏览器自带的方法解码
      this.pdfh5 = new Pdfh5("#demo1", {
        data: decodedBase64,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#demo {
  width: 100%;
  height: 260px;
 
}
#demo1 {
  width: 100%;
  height: 250px;
 
}
#demo ::v-deep .viewerContainer{
    overflow: hidden !important;
 }
 #demo1 ::v-deep .viewerContainer{
    overflow: hidden !important;
 }

</style>